import React from "react";
import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaTwitter,
  FaLinkedin,
} from "react-icons/fa";
import { fresha_url } from "../fresha";

const iconStyle = (Icon) => <Icon />;

export const footerSocialData = [
  {
    name: "Facebook",
    icon: iconStyle(FaFacebook),
    link: "https://www.facebook.com/diamondbeauty.blenheim.2020",
  },
  {
    name: "Instagram",
    icon: iconStyle(FaInstagram),
    link: "https://www.instagram.com/diamondnailsblenheim2020/",
  },
];

export const footerData = [
  {
    town: "BLEMHEIM",
    title: "Diamond Nails",
    links: ["14 Maxwell Road", "Blenheim"],
    tel_no: "+64 3578 4890",
    tel: +6435784890,
    icon: iconStyle(FaFacebook),
  },
  {
    town: "BLEMHEIM",
    title: "Diamond Massage & Beauty",
    links: ["13 Charles Street", "Blenheim"],
    tel_no: "+64 21 0890 7408",
    tel: +642108907408,
    icon: iconStyle(FaFacebook),
  },
  {
    town: "PICTON",
    title: "Diamond Massage & Beauty",
    links: ["3/6 London Quay ", "Picton, Marlborough"],
    tel_no: "03-573 5220",
    tel: +645735220,
    icon: iconStyle(FaFacebook),
  },
  {
    town: "KAIKOURA ",
    title: "Diamond Massage & Beauty",
    links: ["2/78 Beach Road", "Kaikoura "],
    icon: iconStyle(FaFacebook),
    tel_no: "03-319 3336",
    tel_link: "tel: +643193336",
  },
];

export const LocationData = [
  {
    town: "BLENHEIM",
    title: "Diamond Nails",
    operatorId: "67dcd66f7b815d4b8130ff16",
    links: ["14 Maxwell Road, Blenheim", "Mon-Sun 9am - 6pm"],
    tel_no: "+64 3578 4890",
    tel_link: "tel: +6435784890",
    icon: iconStyle(FaFacebook),
    email: "diamondnailsblenheim@gmail.com",
    fb: "https://www.facebook.com/diamondbeauty.blenheim.2020",
    fresha: "/booking/diamond-nail-blenheim",
    img: "/images/location/blemheim2.avif",
  },
  {
    town: "BLENHEIM",
    title: "Diamond Massage & Beauty",
    operatorId: "67f5d0791606aba4ec43950b",
    links: ["13 Charles Street, Blenheim", "", "Mon-Sun 9am - 6pm"],
    tel_no: "+64 3927 3297",
    tel_link: "tel: +6439273297",
    email: "diamondnailsblenheim@gmail.com",
    icon: iconStyle(FaFacebook),
    fb: "https://www.facebook.com/diamondmassageandbeautyblenheim/",
    fresha: "/booking/diamond-massage-beauty-blenheim",
    img: "/images/location/blemheim.avif",
  },
  {
    town: "PICTON",
    title: "Diamond Massage & Beauty",
    operatorId: "67dcd66f7b815d4b8130ff17",
    links: ["3/6 London Quay, Picton", "Marlborough", "Mon-Sun 9am - 6pm"],
    tel_no: "+64 3573 5220",
    tel_link: "tel: +6435735220",
    email: "diamondbeautypicton@gmail.com",
    email_link: "mailto:diamondbeautypicton@gmail.com",
    icon: iconStyle(FaFacebook),
    fb: "https://www.facebook.com/diamondbeautypicton/",
    fresha: "/booking/diamond-picton",
    img: "/images/location/picton.avif",
  },
  // {
  //   town: "KAIKOURA",
  //   title: "Diamond Massage & Beauty",
  //   operatorId: "67dcd66f7b815d4b8130ff18",
  //   links: ["2/78 Beach Road, Kaikoura", "Mon-Sun 9am - 7pm"],
  //   icon: iconStyle(FaFacebook),
  //   tel_no: "+64 3319 3336",
  //   tel_link: "tel: +6433193336",
  //   email: "diamondbeautykaikoura@gmail.com",
  //   email_link: "mailto:diamondbeautykaikoura@gmail.com",

  //   fb: "https://www.facebook.com/diamondbeautykaikoura",
  //   fresha: "/booking/diamond-kaikoura",
  //   img: "/images/location/kaikoura.avif",
  // },
];
